// extracted by mini-css-extract-plugin
export var gif = "_kw-0";